import { useEffect, useState } from 'react'

const minimumThreshold = 80
export const useKeyboardInset = (): number => {
  const [inset, setInset] = useState(0)

  useEffect(() => {
    const vv = window.visualViewport
    const initialHeight = vv?.height ?? window.innerHeight

    const update = () => {
      if (vv) {
        const diff = initialHeight - vv.height
        setInset(diff > minimumThreshold ? diff : 0)
      } else {
        const diff = initialHeight - window.innerHeight
        setInset(diff > minimumThreshold ? diff : 0)
      }
    }

    if (vv) {
      vv.addEventListener('resize', update)
      vv.addEventListener('scroll', update)
    }
    window.addEventListener('resize', update)

    return () => {
      if (vv) {
        vv.removeEventListener('resize', update)
        vv.removeEventListener('scroll', update)
      }
      window.removeEventListener('resize', update)
    }
  }, [])

  return inset
}
